import React, { useState } from "react";
import PushPinIcon from "@mui/icons-material/PushPin";
import "./styles.css";
import { t, Trans } from "adapters/i18n";

export const LegendaAlturaForragem = () => {
  const [open, setOpen] = useState(false);

  const handleOpenLegenda = (openLegenda) => {
    setOpen(openLegenda);
  };

  return (
    <div
      className="captionFooter"
      onMouseEnter={() => handleOpenLegenda(true)}
      onMouseLeave={() => handleOpenLegenda(false)}
    >
      <p className="captionFooterTitle">{t("statusIndicator:caption")}</p>

      {open && (
        <ul>
          <div>
            <PushPinIcon className="greenPin" sx={{ fontSize: 16 }} />
            <li>
              <Trans
                i18nKey="statusIndicator:collect-inside-pasture"
                components={{ bold: <strong /> }}
              />
            </li>
          </div>
          <div>
            <PushPinIcon className="redPin" sx={{ fontSize: 16 }} />{" "}
            <li>
              <Trans
                i18nKey="statusIndicator:collect-outside-pasture"
                components={{ bold: <strong /> }}
              />
            </li>
          </div>
          <div>
            <PushPinIcon className="grayPin" sx={{ fontSize: 16 }} />{" "}
            <li>
              <Trans
                i18nKey="statusIndicator:collect-without-localization"
                components={{ bold: <strong /> }}
              />
            </li>
          </div>
        </ul>
      )}
    </div>
  );
};

export default LegendaAlturaForragem;
